import { render, staticRenderFns } from "./language_switcher.vue?vue&type=template&id=0924787e&"
import script from "./language_switcher.vue?vue&type=script&lang=js&"
export * from "./language_switcher.vue?vue&type=script&lang=js&"
import style0 from "./language_switcher.vue?vue&type=style&index=0&id=0924787e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports